import { z } from 'zod';
import { grade } from '#enums/class';
import { phoneValidator } from '#validators/common/phone-validator';
export const registerUserSchema = z
    .object({
    firstname: z.string().min(2, 'Le prénom est requis'),
    lastname: z.string().min(2, 'Le nom est requis'),
    email: z.string().email("L'email est invalide"),
    grade: z.enum(grade, {
        required_error: 'Le niveau est requis',
    }),
    password: z
        .string()
        .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,20}$/, 'Le mot de passe est invalide'),
    confirmPassword: z.string().min(1, 'La confirmation du mot de passe est requis'),
    phoneNumber: z
        .string()
        .min(1, 'Le téléphone est requis')
        .refine(...phoneValidator),
    cgu: z.boolean().refine((value) => value, {
        message: 'Vous devez accepter les CGU',
    }),
})
    .refine((form) => form.password === form.confirmPassword, {
    message: 'Le mot de passe est différent',
    path: ['confirmPassword'],
});
